<template>
  <div style="width: 100%">
    <v-autocomplete
        v-model="value"
        :items="values"
        item-text="name"
        item-value="uid"
        :label="title"
        chips
        small-chips
        deletable-chips
        multiple
    ></v-autocomplete>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-ad-placement-dropdown-multiple",
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def(""),
    items: VueTypes.arrayOf(VueTypes.string)
  },
  computed: {
    value: {
      get: function () {
        return this.items;
      },
      set: function (value) {
        this.$emit("update:items", value);
      }
    },
    values() {
      return RedactorUtils.getAdPlacements();
    }
  }
}
</script>